<div *ngIf="!isCreationMode">
    @if (_item?.status === ECpmCTaskStatusApiEnum.SUCCESS) {
        <p-message severity="success" icon="pi pi-check">Task finished successfully</p-message>
    }
    @if (_item?.status === ECpmCTaskStatusApiEnum.IN_PROGRESS) {
        <p-message severity="info" icon="pi pi-spinner pi-spin">Task is in progress</p-message>
    }
    @if (_item?.status === ECpmCTaskStatusApiEnum.FAILED) {
        <p-message severity="error" icon="pi pi-exclamation-triangle">Task finished in error</p-message>
    }
    @if (shouldWarnResetOnChangeAndDirty) {
        <p-message severity="warn" icon="pi pi-exclamation-triangle">
            @if (_functionDirty) {
                {{ taskFunctionChangeFirstSentence }}
            } @else if (_inputsDirty) {
                {{ taskInputChangeFirstSentence }}
            }
            {{ resetWarningSentence }}
        </p-message>
    }
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content
        [showDefaultFormFooter]="true"
        [showCreate]="(isCreationMode && _stepperStep === _stepperMax) || !isCreationMode"
        [showPrevious]="taskType !== undefined && isCreationMode && true"
        [previousEnabled]="_stepperStep > 1"
        [showNext]="taskType !== undefined && isCreationMode && _stepperStep !== _stepperMax"
        [nextEnabled]="_stepperStep < _stepperMax"
        [contentClasses]="['floatingLabelContainer']"
    >
        @if (isCreationMode) {
            <p-stepper [value]="_stepperStep">
                <p-step-list>
                    <p-step [value]="1" [disabled]="true">General</p-step>
                    <p-step [value]="2" [disabled]="true">Body</p-step>
                    @if (taskType === ECpmCTaskTypeApiEnum.SMART || taskType === ECpmCTaskTypeApiEnum.SIMPLE) {
                        <p-step [value]="3" [disabled]="true">Function</p-step>
                    }
                </p-step-list>
                <p-step-panels>
                    <p-step-panel [value]="1">
                        <ng-template #content><div *ngTemplateOutlet="generalPart"></div></ng-template>
                    </p-step-panel>
                    <p-step-panel [value]="2">
                        <ng-template #content><div *ngTemplateOutlet="bodyPart"></div></ng-template>
                    </p-step-panel>
                    @if (taskType === ECpmCTaskTypeApiEnum.SMART || taskType === ECpmCTaskTypeApiEnum.SIMPLE) {
                        <p-step-panel [value]="3">
                            <ng-template #content>
                                <div class="mb-3">
                                    <p-message
                                        severity="info"
                                        text="This step is optional. Select a function to create a Smart Task, or skip to create a Simple Task."
                                    ></p-message>
                                </div>
                                <div *ngTemplateOutlet="logicPart"></div>
                            </ng-template>
                        </p-step-panel>
                    }
                </p-step-panels>
            </p-stepper>
        } @else {
            <p-tabs value="general">
                <p-tablist>
                    <p-tab value="general">General</p-tab>
                    <p-tab value="default">Body</p-tab>
                    @if (taskType === ECpmCTaskTypeApiEnum.SMART || taskType === ECpmCTaskTypeApiEnum.SIMPLE) {
                        <p-tab value="logic">Function</p-tab>
                    }
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel value="general"><div *ngTemplateOutlet="generalPart"></div></p-tabpanel>
                    <p-tabpanel value="default"><div *ngTemplateOutlet="bodyPart"></div></p-tabpanel>
                    @if (taskType === ECpmCTaskTypeApiEnum.SMART || taskType === ECpmCTaskTypeApiEnum.SIMPLE) {
                        <p-tabpanel value="logic"><div *ngTemplateOutlet="logicPart"></div></p-tabpanel>
                    }
                </p-tabpanels>
            </p-tabs>
        }

        <ng-template #generalPart>
            <div class="floatingLabelContainer">
                <p-floatlabel variant="on">
                    <p-treeSelect
                        formControlName="parent_uuid"
                        containerStyleClass="width-form"
                        [options]="taskGroupsTreeNodes"
                        title="Select a parent group for this task"
                        emptyMessage="No group found"
                        [filter]="true"
                        [filterInputAutoFocus]="true"
                        selectionMode="single"
                        [showClear]="true"
                        appendTo="body"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="35"
                        [virtualScrollOptions]="{scrollHeight: '20rem'}"
                    ></p-treeSelect>
                    <label for="parent_uuid">Parent Group</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <input id="name" type="text" pInputText formControlName="name" />
                    <label for="name">Name</label>
                </p-floatlabel>

                <div class="hcol-flex">
                    <div class="hcol-33 floatingLabelContainer">
                        <p-floatlabel variant="on">
                            <p-datepicker
                                id="due_date"
                                formControlName="due_date"
                                [showTime]="true"
                                [showIcon]="true"
                                [readonlyInput]="true"
                                [showClear]="true"
                                appendTo="body"
                            ></p-datepicker>
                            <label for="due_date">Due Date</label>
                        </p-floatlabel>
                    </div>
                    <div class="hcol-33 floatingLabelContainer">
                        <p-floatlabel variant="on">
                            <p-datepicker
                                id="start_date"
                                formControlName="start_date"
                                [showTime]="true"
                                [showIcon]="true"
                                [readonlyInput]="true"
                                [showClear]="true"
                                appendTo="body"
                            ></p-datepicker>
                            <label for="start_date">Start Date</label>
                        </p-floatlabel>
                    </div>
                    <div class="hcol-33 floatingLabelContainer">
                        <p-floatlabel variant="on">
                            <p-datepicker
                                id="end_date"
                                formControlName="end_date"
                                [showTime]="true"
                                [showIcon]="true"
                                [readonlyInput]="true"
                                [showClear]="true"
                                appendTo="body"
                            ></p-datepicker>
                            <label for="end_date">End Date</label>
                        </p-floatlabel>
                    </div>
                </div>

                <p-floatlabel variant="on">
                    <textarea id="brief" rows="5" cols="30" pInputTextarea formControlName="brief"></textarea>
                    <label for="brief">Brief</label>
                </p-floatlabel>

                @if (options.length > 0) {
                    <p-floatlabel variant="on">
                        <p-listbox
                            id="options"
                            formControlName="options"
                            [options]="options"
                            [multiple]="true"
                            [checkbox]="true"
                            [metaKeySelection]="false"
                            [showToggleAll]="false"
                            optionLabel="label"
                            optionValue="tag"
                            class="w-full"
                        />
                    </p-floatlabel>
                }
                <p-floatlabel variant="on">
                    <p-treeselect
                        [formControl]="dependenciesForm"
                        containerStyleClass="width-form"
                        [options]="tasksTreeNodes"
                        title="Select depending tasks of the current task"
                        emptyMessage="No task found"
                        [filter]="true"
                        [filterInputAutoFocus]="true"
                        selectionMode="multiple"
                        [showClear]="true"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="35"
                        [virtualScrollOptions]="{scrollHeight: '20rem'}"
                        appendTo="body"
                    />
                    <label for="parent_uuid">Dependencies</label>
                </p-floatlabel>
            </div>
        </ng-template>

        <ng-template #bodyPart>
            <div class="floatingLabelContainer">
                <p-editor
                    id="description"
                    formControlName="description"
                    [readonly]="dialogOpenMode === EDialogOpenMode.READ_ONLY"
                    [style]="{height: '30rem'}"
                >
                    @if (dialogOpenMode === EDialogOpenMode.READ_ONLY) {
                        <ng-template #header> </ng-template>
                    }
                </p-editor>
            </div>
        </ng-template>

        <ng-template #logicPart>
            @if (taskType === ECpmCTaskTypeApiEnum.SIMPLE) {
                <div class="mb-3">
                    <p-message
                        severity="info"
                        text="Select a function to convert this task to a Smart Task."
                    ></p-message>
                </div>
            } @else if (taskType === ECpmCTaskTypeApiEnum.SMART) {
                <div class="mb-3">
                    <p-message
                        severity="info"
                        text="Remove the function to convert this task to a Simple Task."
                    ></p-message>
                </div>
            }
            <p-floatlabel variant="on">
                <p-treeSelect
                    formControlName="function"
                    containerStyleClass="width-form"
                    [options]="_functionsTree"
                    title="Select a function for this task"
                    emptyMessage="No function found"
                    [filter]="true"
                    [filterInputAutoFocus]="true"
                    selectionMode="single"
                    [showClear]="true"
                    appendTo="body"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="35"
                    [virtualScrollOptions]="{scrollHeight: '20rem'}"
                    (onClear)="onFunctionChanged()"
                    (onSelectionChange)="onFunctionChanged()"
                ></p-treeSelect>
                <label for="function">Function</label>
            </p-floatlabel>

            <div class="hcol-flex logic-io-flex mt-4">
                @if (_objectStoreEntriesTransientCache?.isInitialized) {
                    <div class="hcol-50">
                        <app-action-jobs-function-io-editor
                            side="input"
                            [taskLabel]="currentTaskLabel"
                            [plugin]="_selectedPlugin"
                            [pluginFunction]="_selectedPluginFunction"
                            [iosMapping]="_inputsMappings"
                            [readOnly]="dialogOpenMode === EDialogOpenMode.READ_ONLY"
                            [objectStoreEntriesTransientCache]="_objectStoreEntriesTransientCache"
                            (changedEvent)="onTaskIoChanged($event)"
                            [inputChangeConfirmation]="
                                shouldWarnResetOnChange ? getTaskChangeConfirmation(true) : undefined
                            "
                            (validityChangedEvent)="_inputsMappingValid = $event"
                        ></app-action-jobs-function-io-editor>
                    </div>
                    <div class="hcol-50">
                        <app-action-jobs-function-io-editor
                            side="output"
                            [taskLabel]="currentTaskLabel"
                            [plugin]="_selectedPlugin"
                            [pluginFunction]="_selectedPluginFunction"
                            [iosMapping]="_outputsMappings"
                            [readOnly]="dialogOpenMode === EDialogOpenMode.READ_ONLY"
                            [objectStoreEntriesTransientCache]="_objectStoreEntriesTransientCache"
                            (validityChangedEvent)="_outputsMappingValid = $event"
                        ></app-action-jobs-function-io-editor>
                    </div>
                }
            </div>
        </ng-template>
    </app-ibase-cru-modal-content>
</form>
